'use strict';

var _ = require('lodash');
var MappedBookingsController = function MappedBookingsController($scope, mappedBookingsDataRetrieverService) {
  $scope.market = _.get($scope, 'entityData.market', '');
  $scope.route = _.get($scope, 'entityData.route', '');
  $scope.spos = _.get($scope, 'entityData.spos', '');
  $scope.departureDate = _.get($scope, 'entityData.departureDateMoment', '');
  mappedBookingsDataRetrieverService.getData($scope.mode, $scope.screen, $scope.entities, $scope.entityData).then(function (mappedBookingsData) {
    $scope.mappedBookingsData = mappedBookingsData;
  });
};
MappedBookingsController.$inject = ['$scope', 'MappedBookingsDataRetrieverService'];
module.exports = MappedBookingsController;